/*eslint-disable no-useless-constructor */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import NetworkSettings from './NetworkSettings/NetworkSettings';
import ConfigurationTable from './configurationTable/configurationTable';
import ClaimsConfigurationTable from './ClaimsLableConfiguration/ClaimsConfigurationTable';
import PriceComparison from './PriceComparisonConfiguration/PriceComparison';
//import FeaturesConfigurationTable from './FeaturesConfiguration/FeaturesConfigurationTable';
import Header from '../../components/common/Header/Header';
import { ToastContainer, toast } from 'react-toastify';
import ClaimsConfiguration from './ClaimsConfiguration/ClaimsConfiguration';

import 'react-web-tabs/dist/react-web-tabs.css';
import './configuration.scss';
//import './preference.scss';

class Configuration extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Container fluid className="claims-details">
          <Header
            linkTo={'/admin/admin-dashboard'}
            header={t('admin.pages.admin_configuration.module')}
          />

          <Row>
            <Col>
              <Tabs defaultTab="vertical-tab-one" vertical>
                <TabList>
                  <Tab tabFor="vertical-tab-one" role="navigation">
                    Network Setting
                  </Tab>
                  <Tab tabFor="vertical-tab-two" role="navigation">
                    Network Configuration
                  </Tab>
                  {/*<Tab tabFor="vertical-tab-three" role="navigation">
                    Claim Labels Configuration
                  </Tab> */}
                  <Tab tabFor="vertical-tab-five" role="navigation">
                    Claims Configuration
                  </Tab>
                  <Tab tabFor="vertical-tab-four" role="navigation">
                    Cost Estimator Tool Configuration
                  </Tab>
                  {/*<Tab tabFor="vertical-tab-four" role="navigation">Features Configuration</Tab> */}
                  {/*<Tab tabFor="vertical-tab-four" role="navigation">Find Provider Setting</Tab> */}
                </TabList>

                <TabPanel tabId="vertical-tab-one" className="tab-contant-info">
                  <NetworkSettings />
                </TabPanel>

                <TabPanel tabId="vertical-tab-two" className="tab-contant-info">
                  <ConfigurationTable />
                </TabPanel>

                <TabPanel
                  tabId="vertical-tab-three"
                  className="tab-contant-info"
                >
                  <ClaimsConfigurationTable />
                </TabPanel>

                <TabPanel
                  tabId="vertical-tab-five"
                  className="tab-contant-info"
                >
                  <ClaimsConfiguration />
                </TabPanel>

                <TabPanel
                  tabId="vertical-tab-four"
                  className="tab-contant-info"
                >
                  <PriceComparison />
                </TabPanel>

                {/*<TabPanel tabId="vertical-tab-six" className="tab-contant-info">
                  <FeaturesConfigurationTable />
                </TabPanel> */}

                {/*<TabPanel tabId="vertical-tab-four" className="tab-contant-info">
                  <FindProviderSettings />
                </TabPanel> */}
              </Tabs>
              <div className="toastify">
                <ToastContainer
                  draggable
                  pauseOnHover
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  autoClose={5000}
                  position="top-center"
                  newestOnTop={false}
                  hideProgressBar={false}
                  className="toastcontainer"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Configuration);
